import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getTermometroPedagogico(params): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const { data } = await api.get<ConsolidationSummaryType>('/termometro/pedagogico/', {
    params: {
      name: params.name
    }
  });
  return data;
}

type QueryFnType = typeof getTermometroPedagogico;

function useTermometroPedagogico(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['termometro-pedagogico', params.name],
    queryFn: () => getTermometroPedagogico(params),
  });
}

export { getTermometroPedagogico, useTermometroPedagogico };
